// extracted by mini-css-extract-plugin
module.exports = {"bodyDiv":"orderDetail_bodyDiv__RumDr","bodyList":"orderDetail_bodyList__5g9LR","buttonDivSty":"orderDetail_buttonDivSty__2E24B","popupStyle":"orderDetail_popupStyle__3zYZ-"};